import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withContext, getContext, withHandlers } from 'recompose'


import { updateAnswer } from '../actions'
import Indicators from '../components/Indicators'

const withStore = compose(
    withContext({ store: PropTypes.object }, () => {}),
    getContext({ store: PropTypes.object }),
  )

function mapStateToProps(state) {

    const { selectedAssessment, selectedActivity} = state

    return {
      selectedAssessment,
      selectedActivity
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateAnswer: (e) => { dispatch(updateAnswer(e.target.name,e.target.value,ownProps.store))}
    }
}


export default compose(
    withStore,
    withHandlers({
          isIndicatorChecked: props => (answers,activityId,levelId,indicatorId) => {
          return answers.find(answer => answer.activityId === activityId
                  && answer.levelId === levelId && answer.indicatorId === indicatorId)
        }
    }),
    connect(
      mapStateToProps,
      mapDispatchToProps)
  )(Indicators)


// WEBPACK FOOTER //
// ./src/indicators/containers/Indicators.js